const signInEnum = Object.freeze({
  BASELINE: 'Baseline',
  APPLICATION_INFO: '',
  LEGACY_BASELINE: 'Legacy Baseline Login',
  LEGACY_DESCRIPTION: 'Please enter your username and password from a past account made before July 2024 to sync that accounts data.'});

export default signInEnum;
